const NairaIcon = () => (
  <div className="flex items-center justify-center w-6 h-6 rounded-full">
    <span className="text-black font-bold">₦</span>
  </div>
);

export default NairaIcon;
